import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CompositeId, ProfileType } from '@capital-access/profiles/common';
import { CompanyContact } from '../../models/company-contact.models';
import { PROFILE_COMPONENTS_COMMON_LOCALIZATION_SCOPE } from '../../models/constants';

@Component({
  selector: 'ca-primary-contacts-at-profiles-icon',
  templateUrl: './primary-contacts-at-profiles-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrimaryContactsAtProfilesIconComponent {
  localizationScope = PROFILE_COMPONENTS_COMMON_LOCALIZATION_SCOPE;

  isPrimary: boolean = false;
  primaryContactsAt: string[] = [];

  @Input() iconClass: string = 'ms-1 align-bottom';
  @Input() iconSizeClass: string = 'f-i-sm';
  @Input() companyId?: CompositeId;
  @Input() profileType!: ProfileType;
  @Input() container: string = 'target';
  @Input() crmId: number | null | undefined;
  @Input() prId: number | null | undefined;

  @Input() set companyContacts(companyContacts: CompanyContact[]) {
    this.primaryContactsAt = companyContacts
      ?.filter(companyContacts => companyContacts.isPrimaryContact)
      ?.map(({ companyName }) => companyName);

    if (this.profileType === ProfileType.Institution) {
      this.isPrimary =
        !!this.companyId &&
        !!companyContacts.find(
          companyContact => companyContact.companyId == this.companyId!.toString() && companyContact.isPrimaryContact
        );
    } else {
      this.isPrimary = this.primaryContactsAt?.length > 0;
    }
  }

  get isBdOnly() {
    return !this.crmId && this.prId;
  }

  getIconClass() {
    if (this.isPrimary) {
      return this.crmId ? (this.prId ? 'f-i-mixed-primary text-primary-600' : 'f-i-crm-primary text-primary-600') : '';
    }
    return this.crmId ? (this.prId ? 'f-i-mixed-non-primary text-muted' : 'f-i-crm text-muted') : '';
  }

  getIconTitle() {
    if (this.crmId) {
      if (this.prId) {
        if (this.isPrimary) {
          return 'primaryContactBdCrmIconTitleAt';
        } else {
          return 'contactBdCrmIconTitle';
        }
      } else {
        if (this.isPrimary) {
          return 'primaryContactCrmOnlyIconTitleAt';
        } else {
          return 'contactCrmOnlyIconTitle';
        }
      }
    }
    return null;
  }
}
